import { createStore } from "vuex";
import router from "../router";
import { message } from "ant-design-vue";
import { login, UserInfo } from "/src/api/login.js";
import { getClub } from "/src/api/selectClub.js";
import { getOption } from "/src/api/login.js";
import { Search as searchMedicine } from "/src/api/medicine.js";
import { Search as searchPrescription } from "/src/api/prescription.js";
import { Search as searchSyndromeList } from "/src/api/syndrome.js";
import { Search as searchDiseaseList } from "/src/api/disease.js";
import { Search as searchPermissionList } from "/src/api/permission.js";
import { Search as searchEmployeeList } from "/src/api/employee.js";
import { Search as searchRoleList } from "/src/api/role.js";
import { SearchAllclubList as SearchAllclubList } from "/src/api/club.js";

export default createStore({
  state: {
    pageState: "login",
    // 登录人信息
    employee: {},
    token: "",
    loginAuthority: "", //权限
    pages: [],
    // pages: [{ name: "疾病名管理", link: "/" }],
    activeKey: 0,
    clubs: [],
    club: {},
    selectClub: {
      visible: false,
      control: false,
    },
    tableSize: 12,
    // openKeys: ["学术管理"],
    openKeys: [],
    prescriptionType: [
      {
        displayName: "秘方", // 显示出的名字
        dataField: "Mifang", // 从这个字段获取数据
        aiCategory: "Mifang", // 处方关联界面，关联的类型
        prescriptionType: "中药处方", // 能被关联的处方的type
        prescriptionCategory: "Mifang", // 能被关联的处方的category
      },
      {
        displayName: "经方", // 显示出的名字
        dataField: "Jingfang", // 从这个字段获取数据
        aiCategory: "Jingfang", // 处方关联界面，关联的类型
        prescriptionType: "中药处方", // 能被关联的处方的type
        prescriptionCategory: "Jingfang", // 能被关联的处方的category
      },
      {
        displayName: "药对", // 显示出的名字
        dataField: "drugPair", // 从这个字段获取数据
        aiCategory: "药对", // 处方关联界面，关联的类型
        prescriptionType: "中药处方", // 能被关联的处方的type
        prescriptionCategory: "药对", // 能被关联的处方的category
      },
      {
        displayName: "疾病穴位处方", // 显示出的名字
        dataField: "diseaseAcupoints", // 从这个字段获取数据
        aiCategory: "疾病穴位处方", // 处方关联界面，关联的类型
        prescriptionType: "穴位处方", // 能被关联的处方的type
        prescriptionCategory: "穴位处方", // 能被关联的处方的category
      },
      {
        displayName: "症候穴位处方", // 显示出的名字
        dataField: "syndromeAcupoints", // 从table传入智能处方
        aiCategory: "症候穴位处方", // 处方关联界面，关联的类型
        prescriptionType: "穴位处方", // （智能处方）能被关联的处方的type
        prescriptionCategory: "穴位处方", // 能被关联的处方的category
      },
    ],
    selectedKeys: [],
    links: [
      // {
      //   name: "日常管理统计",
      //   subMenus: [{ name: "员工管理" }, { name: "门诊日报" }],
      // },
    ],
    medicineList: [], 
    prescriptionList: [],
    syndromeList: [],
    diseaseList: [],
    permissionList: [],
    employeeList: [],
    roleList: [],
    allclubList: [],
  },
  mutations: {
    // 登录功能，获取token、所在门诊、功能
    async getUserInfo(state, userInfo) {
      //登录返回token、所在所有门诊
      let token;
      let clubs;
      let employee;
      let res;
      // console.log(!localStorage.getItem("token"));

      if (userInfo.type == "auto") {
        token = localStorage.getItem("token");
        if (token) {
          res = await UserInfo();
        } else {
          // 无 token 时明确切换到登录页
          state.pageState = "login";
          return;
        }
      } else {
        res = await login(userInfo);

        token = res.data.jwt;
      }

      clubs = res.data.clubs;
      employee = res.data.employee;

      //将token、所在门诊、员工信息存入localStorage
      localStorage.setItem("token", token);
      // localStorage.setItem("clubs", clubs);
      // localStorage.setItem("employee", employee);
      // state.token = localStorage.getItem("token");
      state.clubs = res.data.clubs;
      state.employee = res.data.employee;

      let res2 = await getClub();

      state.club = res2.data;
      if (!res2.data) {
        state.selectClub.visible = true;
        state.selectClub.control = false;
      }
      //判断state.club是否为空
      //获取用户所有可用功能
      if (state?.club?.id) {
        let res3 = await getOption();
        if (res3.errCode == 0) {
          state.links = res3.data;
        }
        // console.log(state.links);

        if (!state.links[0]?.subMenus) {
          message.warning("您在当前门店暂无权限！");
        } else {
          // 判断是否有 redirect 参数（从外部链接未登录被拦截后携带的跳转目标）
          const redirectQuery = router.currentRoute.value.query.redirect;
          if (redirectQuery) {
            // 有 redirect 参数，跳转到指定页面（外部链接直达）
            // redirectQuery 格式如 "/couponAssociation?usedAt=2026-07-2"
            const [redirectPath, redirectQueryString] = String(redirectQuery).split('?');
            const redirectQueryObj = {};
            if (redirectQueryString) {
              redirectQueryString.split('&').forEach(pair => {
                const [key, value] = pair.split('=');
                if (key) redirectQueryObj[key] = decodeURIComponent(value || '');
              });
            }
            await router.push({ path: redirectPath, query: redirectQueryObj });
            // 跳转后清除 URL 中的 redirect 参数，防止刷新后再次被处理
            await router.replace({
              path: redirectPath,
              query: { ...redirectQueryObj },
            });
          } else if (userInfo.type != "auto") {
            // 无 redirect，且是手动登录 → 跳转到用户拥有的第一个功能页面
            if (!state.links[0]?.subMenus[0]?.routePath) {
              message.warning("当前路径存在异常，请手动切换菜单");
            }
            await router.push({
              path: state.links[0]?.subMenus[0]?.routePath
                ? state.links[0]?.subMenus[0]?.routePath
                : "/",
            });
          }
        }
        // 初始化 pages（顶部标签栏）
        const firstMenu = state.links[0]?.subMenus?.[0];
        const currentRoute = router.currentRoute.value;
        const routeName = currentRoute.name;
        // 如果当前路由有名称（说明跳转到了某个具体页面），找到对应路由配置加入 pages
        const routeConfig = router.options.routes.find(r => r.name === routeName);
        state.pages = routeConfig
          ? [{ name: routeConfig.name, link: routeConfig.path }]
          : firstMenu
            ? [{ name: firstMenu.name, link: firstMenu.routePath }]
            : [];

        let name = router.currentRoute.value.name;
        state.openKeys = name;
        state.selectedKeys = [name];
        this.commit("changePage", {
          name,
          query: router.currentRoute.value.query,
        });
      }

      // state.clubs = res2.data;
      state.pageState = "home";
      message.success("登录成功！");
      //登录后获取全局的数据
      this.dispatch("getMedicineList");
      this.dispatch("getPrescriptionList");
      this.dispatch("getSyndromeList");
      this.dispatch("getDiseaseList");
      this.dispatch("getPermissionList");
      this.dispatch("getEmployeeList");
      this.dispatch("getRoleList");
      this.dispatch("getAllclubList");
    },
    // 跳转页面并更改顶部和左侧标签
    changePage(state, tabName) {
      //判断是否已开启标签
      let isOpen = false;
      state.pages.forEach((element, i) => {
        // 点击对应pages(标签栏)第几项
        if (tabName.name == element.name) {
          isOpen = true;
        }
      });

      router.options.routes.forEach((element, i) => {
        if (element.name == tabName.name) {
          // 没有此标签则添加
          if (!isOpen) {
            state.pages.push({
              name: element.name,
              link: element.path,
            });
          }

          router.push({ path: element.path, query: tabName.query });
          // console.log("查看成分：" + router.options.routes[i]?.meta?.keepAlive)
          if (router.options.routes[i]?.meta?.keepAlive != undefined) {
            router.options.routes[i].meta.keepAlive = true;
          }

          state.pages.forEach((element, i) => {
            if (tabName.name == element.name) {
              state.activeKey = i;
            }
          });
          // alert(router.options.routes[i].meta.keepAlive)
        }
      });

      this.commit("changeKey", tabName.name);
      if (tabName.delete != undefined) {
        state.pages.forEach((element, i) => {
          if (element.name == tabName.delete) {
            state.pages.splice(i, 1);
          }
        });
      }
    },
    //更改顶部导航栏
    changeKey(state, tabName) {
      // console.log(tabName)

      const childToParentMap = {};
      // 遍历links数组构造映射
      state.links.forEach((parent) => {
        parent.subMenus.forEach((child) => {
          childToParentMap[child.name] = parent.name;
        });
      });
      const parent = childToParentMap[tabName];
      if (parent) {
        // 示例：查找父级名称
        state.openKeys = [childToParentMap[tabName]];
        state.selectedKeys = [tabName];
      } else {
        state.openKeys = [];
        state.selectedKeys = [];
      }
    },
    clearLinks(state){
      state.links = [];
    },
    setMedicineList(state, data) {
      state.medicineList = data;
    },
    setPrescriptionList(state, data) {
      state.prescriptionList = data;
    },
    setSyndromeListList(state, data) {
      state.syndromeList = data;
    },
    setDiseaseListList(state, data) {
      state.diseaseList = data;
    },
    setPermissionList(state, data) {
      state.permissionList = data;
    },
    setEmployeeList(state, data) {
      state.employeeList = data;
    },
    setRoleList(state, data) {
      state.roleList = data;
    },
    setAllClubList(state, data) {
      state.allClubList = data;
    },
    setPageState(state, data) {
      state.pageState = data;
    },
  },
  actions: {
    async getMedicineList() {
      let res = await searchMedicine({ pageSize: -1 });
      if (res.errCode == 0) {
        this.commit("setMedicineList", res.data);
      }
    },
    async getPrescriptionList() {
      let res = await searchPrescription({ includePrescription: true });
      if (res.errCode == 0) {
        this.commit("setPrescriptionList", res.data);
      }
    },
    async getSyndromeList() {
      let res = await searchSyndromeList({ isStandard: true });
      if (res.errCode == 0) {
        this.commit("setSyndromeListList", res.data);
      }
    },
    async getDiseaseList() {
      let res = await searchDiseaseList({ isStandard: true, pageSize: -1 });
      if (res.errCode == 0) {
        this.commit("setDiseaseListList", res.data.records);
      }
    },
    async getPermissionList() {
      let res = await searchPermissionList();

      if (res.errCode == 0) {
        this.commit("setPermissionList", res.data);
      }
    },
    async getEmployeeList() {
      let res = await searchEmployeeList({ clubId: 310 });
      if (res.errCode == 0) {
        this.commit("setEmployeeList", res.data.records);
      }
    },
    async getRoleList() {
      let res = await searchRoleList();
      if (res.errCode == 0) {
        this.commit("setRoleList", res.data);
      }
    },
    async getAllclubList() {
      let res = await SearchAllclubList();
      if (res.errCode == 0) {
        this.commit("setAllClubList", res.data);
      }
    },
  },
  modules: {},
});
